import {createSlice} from '@reduxjs/toolkit';

// ---- import from local actions ----
import {fetchResidentList} from './../actions/ResidentActions';


const ResidentSlice = createSlice({
  name: 'resident',
  initialState: {
    residentList: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchResidentList.pending, (state) => {
        state.residentList.status = 'loading';
      })
      .addCase(fetchResidentList.fulfilled, (state, action) => {
        state.residentList.status = 'idle';
        state.residentList.data = action.payload.result;
      })
      .addCase(fetchResidentList.rejected, (state, action) => {
        state.residentList.status = 'rejected';
        state.residentList.error = action.error.message;
      });
  },
});

export default ResidentSlice.reducer;
